// Sends the ad conversions the server queued in the bs_ads_conv cookie
// (AdConversions concern): paid checkouts and free tool unlocks, to Google Ads
// (gtag) and the Meta pixel (fbq).
//
// Checks on full loads, Turbo visits, frame loads and stream renders, since a free
// unlock lands in place. The cookie is cleared before anything fires, so each
// conversion is sent once; transaction_id lets Google and Meta drop a repeat anyway.

const COOKIE = 'bs_ads_conv';
const COOKIE_PATTERN = /(?:^|;\s*)bs_ads_conv=([^;]*)/;
// gtag is defined up front in layouts/_site_head.html.erb; fbq comes from the
// idle-loaded analytics block there (production only), up to ~3s after load.
const WAIT_MS = 500;
const MAX_WAITS = 20;

function readQueue() {
  const match = document.cookie.match(COOKIE_PATTERN);
  if (!match) return null;
  try {
    const queue = JSON.parse(decodeURIComponent(match[1].replace(/\+/g, ' ')));
    return Array.isArray(queue) ? queue : [];
  } catch {
    return [];
  }
}

function clearQueue() {
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE}=; Max-Age=0; path=/; SameSite=Lax${secure}`;
}

function sendToGoogle(conversion) {
  if (!conversion.send_to || typeof window.gtag !== 'function') return;
  const params = { send_to: conversion.send_to, transaction_id: conversion.transaction_id };
  if (conversion.value) Object.assign(params, { value: conversion.value, currency: conversion.currency });
  window.gtag('event', 'conversion', params);
}

function sendToMeta(conversion) {
  if (!conversion.meta_event || typeof window.fbq !== 'function') return;
  const params = conversion.value ? { value: conversion.value, currency: conversion.currency } : {};
  window.fbq('track', conversion.meta_event, params, { eventID: conversion.transaction_id });
}

function flush(waits = 0) {
  const queue = readQueue();
  if (!queue) return;
  const ready = typeof window.gtag === 'function' && typeof window.fbq === 'function';
  if (!ready && waits < MAX_WAITS) {
    setTimeout(() => flush(waits + 1), WAIT_MS);
    return;
  }

  clearQueue();
  queue.forEach((conversion) => {
    if (!conversion) return;
    [sendToGoogle, sendToMeta].forEach((send) => {
      try {
        send(conversion);
      } catch {
        // tracking must never break the page
      }
    });
  });
}

export function startAdConversions() {
  flush();
  document.addEventListener('turbo:load', () => flush());
  document.addEventListener('turbo:frame-load', () => flush());
  // Fires before the stream renders; the response (and its cookie) has already arrived.
  document.addEventListener('turbo:before-stream-render', () => setTimeout(flush, 0));
}
